export default __webpack_public_path__ + "static/media/logo-myhealthcare.0f48be86.svg";